import { useMemo } from "react";
import useAuth from "../hooks/useAuth";
import { getRoutes } from "./routes";

export const useAppRoutes = () => {
  const { isLoggedIn, loggedInUser } = useAuth();
  const isAdmin = loggedInUser?.isAdmin ?? false;

  return useMemo(() => {
    return getRoutes(isLoggedIn, isAdmin);
  }, [isLoggedIn, isAdmin]);
};
